import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { Box, Grid } from "@mui/material";
import DocumentsList from "./documents-list";
import MediaDocuments from "./media";
import { Track } from "../../types";
import RentalFinancialProposals from "./rental-financial-proposal";
import PageComponentsWrapper from "@/modules/common/components/wrappers/page-components-wrapper";
import MaterialDocuments from "./material";

export default function PropertyDocuments({
  track,
}: Readonly<{ track: Track }>) {
  const { isMobile } = useScreenSize();
  return (
    <Grid container spacing={1}>
      <Grid
        container
        direction="column"
        size={isMobile ? 12 : 8}
        gap={(theme) => theme.nawy.spacing.sm}
      >
        <MediaDocuments />
        <PageComponentsWrapper
          component="property-material-selection"
          page="property-details-documents"
          trackTypeId={track.trackType.id}
        >
          <MaterialDocuments track={track} />
        </PageComponentsWrapper>
      </Grid>
      <Grid size={isMobile ? 12 : 4}>
        <Box
          sx={(t) => ({
            display: "flex",
            flexDirection: "column",
            gap: t.nawy.spacing.sm,
            overflow: "auto",
          })}
        >
          <DocumentsList track={track} />
          <PageComponentsWrapper
            component="rental-financial-proposals"
            page="property-details-documents"
            trackTypeId={track.trackType.id}
          >
            <RentalFinancialProposals track={track} />
          </PageComponentsWrapper>
        </Box>
      </Grid>
    </Grid>
  );
}
